// SHIFTme — shared date formatting utility
// Outputs: 07 April 2026

export function formatDate(dateInput) {
  if (!dateInput) return '';
  // Normalise date-only strings (YYYY-MM-DD) to avoid timezone day-shift
  const normalized =
    typeof dateInput === 'string' && dateInput.length === 10
      ? dateInput + 'T12:00:00'
      : dateInput;
  const date = new Date(normalized);
  if (isNaN(date)) return '';
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
